import { render, staticRenderFns } from "./TimeSeriesData.vue?vue&type=template&id=b938991c&scoped=true"
import script from "./TimeSeriesData.vue?vue&type=script&lang=js"
export * from "./TimeSeriesData.vue?vue&type=script&lang=js"
import style0 from "./TimeSeriesData.vue?vue&type=style&index=0&id=b938991c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b938991c",
  null
  
)

export default component.exports